/* Crumpaw · US units for text written after the page loads: cart lines and quick add.
   Loaded by layout/theme.liquid only when the country is US. Changes the words on screen,
   never a value, so the variant and the order keep the size the store knows ("14 cm"). */
(function () {
  var SWAPS = [
    [/(^|[\s\/,(])14 cm(?=$|[\s,)])/g, '$15.5 in'],
    [/(^|[\s\/,(])16 cm(?=$|[\s,)])/g, '$16.3 in'],
    [/(^|[\s\/,(])18 cm(?=$|[\s,)])/g, '$17.1 in'],
    [/40 × 60 cm/g, '16 × 24 in']
  ];
  var SKIP = { SCRIPT: 1, STYLE: 1, TEMPLATE: 1, TEXTAREA: 1, NOSCRIPT: 1 };

  function fixNode(node) {
    var before = node.nodeValue;
    if (!before || before.indexOf('cm') === -1) return;
    var parent = node.parentNode;
    if (!parent || SKIP[parent.nodeName]) return;
    var after = before;
    for (var i = 0; i < SWAPS.length; i++) after = after.replace(SWAPS[i][0], SWAPS[i][1]);
    if (after !== before) node.nodeValue = after;
  }

  function walk(root) {
    if (root.nodeType === 3) return fixNode(root);
    if (root.nodeType !== 1 && root.nodeType !== 11) return;
    if (SKIP[root.nodeName]) return;
    var tree = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = tree.nextNode())) fixNode(node);
  }

  function start() {
    walk(document.body);
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        if (r.type === 'characterData') fixNode(r.target);
        else for (var j = 0; j < r.addedNodes.length; j++) walk(r.addedNodes[j]);
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();
